/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

import { NAV_ROOT } from '../../constants/navigation';
import { apiSlice } from '../apiSlice';
import { getLoginUrl } from '../utils/loginRedirectUtils';
import { authActions } from './authSlice';
import { globalActions } from '../global/globalSlice';

export const setOrganization = (organizationId, navigate) => async (dispatch, getState) => {
  const { currentUser, organizationId: currentOrgId } = getState().auth;
  const organizations = currentUser?.organizations || [];

  // Reset saved observatory search params if organization is changing
  if (currentOrgId !== organizationId) {
    await dispatch(globalActions.setObservatorySearchParams({}));
  }

  // If the organization does not exist in the user's list of organizations
  // show an error and fall back to the first available organization
  if (organizations.find(org => org.id === organizationId)) {
    dispatch(authActions.organizationChangeComplete(organizationId));
  } else {
    const firstAvailableOrgId = organizations[0]?.id;

    if (firstAvailableOrgId) {
      dispatch(authActions.organizationChangeComplete(firstAvailableOrgId));
      if (navigate) {
        navigate(NAV_ROOT, { replace: true });
      }
    }
  }
};

export const logoutUser = navigate => async (dispatch, getState) => {
  try {
    const loginUrl = getLoginUrl(getState);

    await dispatch(apiSlice.endpoints.logoutUser.initiate());
    await dispatch(authActions.userLogoutComplete());

    if (loginUrl) {
      // login page will not get the correct state (at first) after the `userLogoutComplete` action
      // unless we navigate on the next tick
      setTimeout(() => navigate(loginUrl));
    }
  } catch (error) {}
};
